<template>
    <div>
        <h1 :class="selected ? 'text-sm pt-2' : 'text-xl pt-0.5 font-bold'">
            Garantie
        </h1>
        <sav-fold-card
        v-model="open"
        class="mt-4"
        :close-button="false"
        :id="$options.name"
        :can-open="canOpen"
        >
            <template v-slot:close>
                <span class="font-bold" v-if="selected">
                    {{selected.value == 'no' ? $t('form.ticket-request.non') : $t('form.ticket-request.oui')}}
                </span>
            </template>

            <template v-slot:open>
                <p class="mb-4 text-lg font-bold">{{$t('form.ticket-request.votre_produit_est_il_sous_garantie')}}</p>
                <div class="my-3">
                    <button @click="end({value: 'no'})" class="inline-block px-3 py-1 mr-1 text-center text-white whitespace-no-wrap align-middle bg-red-500 border border-red-400 rounded select-none hover:bg-red-600">
                        <i class="mr-1 fas fa-times"></i>{{$t('form.ticket-request.non')}}
                    </button>
                    <button @click="end({value: 'yes'})" class="inline-block px-3 py-1 text-center text-white whitespace-no-wrap align-middle bg-green-600 border border-green-600 rounded select-none hover:bg-green-700">
                        <i class="mr-1 fas fa-check"></i>{{$t('form.ticket-request.oui')}}
                    </button>
                </div>
            </template>
        </sav-fold-card>
    </div>
</template>

<script>
import FormCardExtension from '@/extends/FormCardExtension'

export default {
    name: 'casino-home',
    extends: FormCardExtension,

    methods: {
        async init() {
            // Set casino default shop data
            this.$formTool.addFormData('sign', {id: "30", name: "GEANT CASINO", label: "GEANT CASINO", img: "https://www.districloud.net/img/gean_log.png"})
            this.selected = null

            // Check if data
            if (this.$formTool.getFormData(this.$options.name)) {
                this.selected = JSON.parse(JSON.stringify(this.$formTool.getFormData(this.$options.name)))
                this.nextBlock = this.getNextBlock()
            }

            // Check can open card after set-case
            this.removeOpenAfterSetCase()
        },

        getNextBlock() {
            let blockData = this.$formTool.blockData(this.$options.name)
            return this.selected && this.selected.value == 'no' ? blockData.next.no : blockData.next.yes
        },

        end(callbackData) {
            this.$formTool.addFormData(this.$options.name, callbackData)
            if (this.selected) {
                this.$emit('update', this.$options.name)
            }
            this.selected = JSON.parse(JSON.stringify(callbackData))
            this.nextBlock = this.getNextBlock()
        },
    },

    mounted() {
        this.init()
    }
}
</script>



// WEBPACK FOOTER //
// src/processes/cards/shop/TicketRequestCard.vue